import IntegrationType from "../../../../types/integration/IntegrationType";
import NotificationIntegrationList from "../NotificationIntegrationList";
import { NOTIFICATION_INTEGRATIONS } from "../../../../helpers/notificationIntegrations";

function List(props: { loading: number, serviceNow: IntegrationType[], refresh: Function, isAdmin: boolean }) {
    return (
        <NotificationIntegrationList
            loading={props.loading}
            parameters={props.serviceNow}
            refresh={props.refresh}
            isAdmin={props.isAdmin}
            config={NOTIFICATION_INTEGRATIONS.servicenow}
            basePath="/admin/integrations/service-now"
            iconClass="fak fa-snow"
            endpointLabel="Event endpoint"
            endpointKey="url"
        />
    );
}

export default List;
